import { ProjectService } from '@services/project.service';
import { HttpClient } from '@angular/common/http';
import { Observable, of, BehaviorSubject, Subscription, firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';

import EmbedJSONMapStyle from '@assets/maps/style.json';
import EmbedJSONMapStyleDark from '@assets/maps/style_dark.json';
import EmbedJSONMapStyleLight from '@assets/maps/style_light.json';
import { ILocationModel, LocationModel } from '@models/Common';

//https://github.com/angular/components/tree/main/src/google-maps#readme

export enum EnumMapStyle {
    DEFAULT = 'default',
    LIGHT = 'light',
    DARK = 'dark'
}

@Injectable({
    providedIn: 'root'
})
export class GoogleMapsService {

    private geocoder: google.maps.Geocoder;

    private ApiLoaded: BehaviorSubject<boolean> = new BehaviorSubject(false);

    private apiLoaded = this.ApiLoaded.asObservable();

    private loadedGoogleMaps: any;

    constructor(private HttpClient: HttpClient, private ProjectService: ProjectService) {

    }

    // CARREGAMENTO INICIAL DO GOOGLE MAPS
    async Init() {

        const googleKey = this.ProjectService.GetSettings()?.GoogleMaps?.Key || '';

        return new Promise((resolve, reject) => {
            if (this.loadedGoogleMaps) {
                // If already loaded, resolve immediately
                resolve(true);
                return;
            }

            // Create the script element
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?libraries=geometry&sensor=false&key=${googleKey}&region=PT&callback=initMap`;
            script.async = true;
            script.defer = true;

            // Set the global callback function
            (window as any).initMap = () => {

                this.geocoder = new google.maps.Geocoder();

                this.loadedGoogleMaps = true;
                this.ApiLoaded.next(true);
                resolve(true);
            };

            // Handle script load error
            script.onerror = () => {
                reject('Google Maps script load error');
                this.loadedGoogleMaps = true;
                this.ApiLoaded.next(false);
            };

            // Append the script to the document
            document.head.appendChild(script);
        });
    }

    /**
     * DEVOLVE OBSERVABLE DO MAPA
     * @returns 
     */
    GetMap() {
        return this.apiLoaded;
    }



    /**
     * 
     * @param style 
     * @returns 
     */
    GetMapStyle(style?: string): google.maps.MapTypeStyle[] {
        //SETUP STYLE FROM JSON FILE
        // return new google.maps.StyledMapType(JSON.parse(JSON.stringify(EmbedJSONMapStyle)), { "name": 'StyledMap' });

        // console.log(this.ProjectService.GetSettings()?.GoogleMaps, style);

        style = (style == undefined && (this.ProjectService.GetSettings()?.GoogleMaps?.Style != undefined || this.ProjectService.GetSettings()?.GoogleMaps.Style == null))
            ? this.ProjectService.GetSettings()?.GoogleMaps?.Style
            : EnumMapStyle.DEFAULT;

        let styleJson = null;

        switch (style) {
            case EnumMapStyle.DARK:
                styleJson = EmbedJSONMapStyleDark;
                break;
            case EnumMapStyle.LIGHT:
                styleJson = EmbedJSONMapStyleLight;
                break;
            case EnumMapStyle.DEFAULT:
                styleJson = EmbedJSONMapStyle;
                break;
            default:
                break;
        }

        return styleJson;
    }

    /**
     * DEPRECATED
     * @param street 
     * @returns 
     */
    async GetCoordenatesFromStreetName(street: string = "") {

        const googleKey = this.ProjectService.GetSettings()?.GoogleMaps?.Key || '';

        // https://maps.google.com/maps/api/geocode/json?address=1600+Amphitheatre+Parkway,+Mountain+View,+CA
        const http = this.HttpClient.get<any>(`https://maps.google.com/maps/api/geocode/json?address=${street}&key=${googleKey}&region=PT`);

        return firstValueFrom(http)
            .then((response: any) => {
                console.log(`Result GET : `, response);

                return response?.status == 'OK' ? response?.results : [];
            })
            .catch(error => {
                console.log(`Error GET : `, error);

                return [];
            });
    }


    /**
    * Geo Code Location
    * @param location 
    * @returns 
    */
    GeoCodeLocation(location: ILocationModel): Promise<ILocationModel> {
        return new Promise((resolve, reject) => {
            let address = [location.Address, location.Locality, location.ZipCode].filter(local => local).join(",");

            if (address) address = address + ", Portugal";

            let request = {
                address: address,
                region: "pt"
            };

            this.geocoder.geocode(request, (results, status) => {
                if (status == 'OK' && results.length > 0) {

                    const location = new LocationModel();

                    location.Coordinates.Latitude = results[0].geometry.location.lat().toString();
                    location.Coordinates.Longitude = results[0].geometry.location.lng().toString();

                    resolve(location);
                }
                else {
                    resolve(new LocationModel());
                }
            });
        });
    }

}
